<div class="last-updated-container">    
    <span [class]="!labelBold ? 'last-updated-description-text' : 'last-updated-description-text-bold' ">{{label}}</span>    
    <div class="nsw-list nsw-list--8" [class.last-updated-tag-colour-nsw-dark]="tagColourNSWDark">
        <span *ngIf="updatedDateDesc" class="nsw-tag">{{updatedDateDesc}}</span>
    </div>
</div>